import type { SVGProps } from 'react';

interface SearchLocationPinProps extends SVGProps<SVGSVGElement> {
  pinFill?: string;
  pinStroke?: string;
}

const SearchLocationPin = ({
  pinFill = '#D4311C',
  pinStroke = '#A51F0F',
  ...props
}: SearchLocationPinProps) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width="1em"
    height="1em"
    viewBox="0 0 25 42"
    fill="none"
    {...props}
  >
    <path
      fill={pinFill}
      stroke={pinStroke}
      d="M24.5 12.5c0 6.35-9.18 14.302-11.708 27.272-.056.284-.528.284-.584 0C9.681 26.802.5 18.85.5 12.5c0-6.627 5.373-12 12-12s12 5.373 12 12Z"
    />
    <circle cx={12.5} cy={12.5} r={5} fill="white" />
  </svg>
);
export default SearchLocationPin;
